import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4 mb-4 mb-md-0">
            <h5>About Asia Academic Press</h5>
            <p>A leading academic publisher dedicated to the advancement of scholarly research and knowledge dissemination across various disciplines in the Asia-Pacific region.</p>
            <div className="social-links mt-3">
              <a href="#" className="me-2"><i className="fab fa-facebook-f"></i></a>
              <a href="#" className="me-2"><i className="fab fa-twitter"></i></a>
              <a href="#" className="me-2"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
    

          <div className="col-md-2 col-6 mb-4 mb-md-0">
            <h5>Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Home</Link></li>
              <li>
                <Link 
                  to="/" 
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.location.pathname === '/') {
                      const aboutSection = document.getElementById('about');
                      if (aboutSection) {
                        const headerOffset = 80;
                        const elementPosition = aboutSection.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                        window.scrollTo({
                          top: offsetPosition,
                          behavior: 'smooth'
                        });
                      }
                    } else {
                      window.location.href = '/#about';
                    }
                  }}
                >
                  About Us
                </Link>
              </li>
              <li><Link to="/author-guidelines">Author Guidelines</Link></li>
              <li><Link to="/submit-paper">Submit Your Paper</Link></li>
            </ul>
          </div>

          <div className="col-md-3 col-6 mb-4 mb-md-0">
            <h5>Our Journal</h5>
            <ul className="footer-links">
              <li>
                <a
                  href="https://asiaentrepreneurshipjournal.com/index.php/jaes/index"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Journal of Asia Entrepreneurship and Sustainability
                </a>
              </li>
            </ul>
          </div>


          <div className="col-md-3">
            <h5>Contact Us</h5>
            <address>
              <p><i className="fas fa-map-marker-alt me-2"></i> New Zealand</p>
              <p><i className="fas fa-envelope me-2"></i> info@asiaacademicpress.com</p>
            </address>
          </div>
        </div>

        <div className="copyright">
          <div className="row">
            <div className="col-md-6 text-center text-md-start">
              &copy; {new Date().getFullYear()} Asia Academic Press. All Rights Reserved.
            </div>
            <div className="col-md-6 text-center text-md-end">
              <Link to="/privacy-policy" className="text-white-50 me-3">Privacy Policy</Link>
              <Link to="/terms-of-use" className="text-white-50">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
